/**
 * @generated SignedSource<<12785a2dd04803a875e0a83874e8bb36>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type LibraryPanelChannelLink_viewer$data = {
  readonly account: {
    readonly billingAccount: {
      readonly canUseChannels: boolean;
    };
  };
  readonly " $fragmentSpreads": FragmentRefs<"LibraryHooksUseLeaveChannel_viewer">;
  readonly " $fragmentType": "LibraryPanelChannelLink_viewer";
};
export type LibraryPanelChannelLink_viewer$key = {
  readonly " $data"?: LibraryPanelChannelLink_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"LibraryPanelChannelLink_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "LibraryPanelChannelLink_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "LibraryHooksUseLeaveChannel_viewer"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Account",
      "kind": "LinkedField",
      "name": "account",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "BillingAccount",
          "kind": "LinkedField",
          "name": "billingAccount",
          "plural": false,
          "selections": [
            {
              "alias": "canUseChannels",
              "args": [
                {
                  "kind": "Literal",
                  "name": "feature",
                  "value": "channels"
                }
              ],
              "kind": "ScalarField",
              "name": "hasAccessToFeature",
              "storageKey": "hasAccessToFeature(feature:\"channels\")"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "0100ff41506522d773cf29a2321a4c53";

export default node;
